export default {
  isRadioId(value) {
    return value.startsWith("dmr-unit:");
  },
  isPhoneNumber(value) {
    return value.startsWith("tel:") && !value.endsWith(";phone-context=pabx");
  },
  isPabxNumber(value) {
    return value.startsWith("tel:") && value.endsWith(";phone-context=pabx");
  },
  removeUriFormatting(value) {
    if (!value.includes(":")) return value;
    if (!value.includes(";")) return value.split(":")[1];
    return value.split(":")[1].split(";")[0];
  },
  constructUri(type, value) {
    let typeFormatMap = {
      radio_id: ["dmr-unit:", ""],
      phone_no: ["tel:", ""],
      pabx_no: ["tel:", ";phone-context=pabx"],
    };

    if (!typeFormatMap[type]) return value;

    let [prefix, postfix] = typeFormatMap[type];
    return prefix + value + postfix;
  },
  stripVisualSeparators(phoneNumber) {
    return phoneNumber.replace(/[-.() ]/g, "");
  },
  formatISODateTime(isoDatetime) {
    let localDate = new Date(isoDatetime);
    return localDate.toLocaleDateString(undefined, {
      day: "numeric",
      month: "short",
      year: "numeric",
      hour: "numeric",
      minute: "numeric",
      hour12: true,
    });
  },
  formatUptime(uptimeInSeconds) {
    if (uptimeInSeconds < 0) return "";
    let seconds = Math.floor(uptimeInSeconds);
    let years = Math.floor(seconds / (365 * 24 * 60 * 60));
    seconds -= years * 365 * 24 * 60 * 60;
    let days = Math.floor(seconds / (24 * 60 * 60));
    seconds -= days * 24 * 60 * 60;
    let hours = Math.floor(seconds / (60 * 60));
    seconds -= hours * 60 * 60;
    let minutes = Math.floor(seconds / 60);
    seconds -= minutes * 60;

    let formattedUptime = [];
    if (years > 0)
      formattedUptime.push(`${years} year${years !== 1 ? "s" : ""}`);
    if (days > 0) formattedUptime.push(`${days} day${days !== 1 ? "s" : ""}`);
    if (hours > 0)
      formattedUptime.push(`${hours} hour${hours !== 1 ? "s" : ""}`);
    if (minutes > 0)
      formattedUptime.push(`${minutes} minute${minutes !== 1 ? "s" : ""}`);
    if (seconds > 0 || formattedUptime.length === 0)
      formattedUptime.push(`${seconds} second${seconds !== 1 ? "s" : ""}`);

    return formattedUptime.slice(0, 3).join(", ");
  },
  expiryStatus(from, to, isPublicIssuer = true) {
    let fromDate = new Date(from);
    let toDate = new Date(to);
    let currentDate = new Date();
    if (currentDate >= toDate) {
      return "Invalid (Expired)";
    }

    if (currentDate < fromDate) {
      return "Invalid (Not yet valid)";
    }

    let timeDifference = toDate.getTime() - currentDate.getTime();
    let daysLeft = Math.ceil(timeDifference / (1000 * 60 * 60 * 24)) - 1;

    if (daysLeft === 0) {
      if (isPublicIssuer) {
        return `Valid (Expires in less than a day)`;
      } else {
        return "Non-Public Issuer (Expires in less than a day)";
      }
    }

    let pluralModifier = "s";
    if (daysLeft === 1) pluralModifier = "";
    if (isPublicIssuer) {
      return `Valid (Expires in ${daysLeft} day${pluralModifier})`;
    } else {
      return `Non-Public Issuer (Expires in ${daysLeft} day${pluralModifier})`;
    }
  },
  getFileDate() {
    const isoNow = new Date().toISOString();
    const isoStripped = isoNow.replaceAll(/[-:T]/g, "").replace(/\.\d+Z/, "z");
    return `backup_${isoStripped}`;
  },
  getTimeZoneNameShort() {
    return new Date()
      .toLocaleDateString(undefined, { day: "2-digit", timeZoneName: "short" })
      .substring(4);
  },
  getTimeZoneNameLong() {
    return new Date()
      .toLocaleDateString(undefined, { day: "2-digit", timeZoneName: "long" })
      .substring(4);
  },
  getDateLabel() {
    return "Date - " + this.getTimeZoneNameShort();
  },
  roleColour(role) {
    switch (role) {
      case "admin":
      case "tenant_admin":
        return "success";
      case "maintainer":
      case "legacy_user":
      case "auditor":
        return "info";
      default:
        return "primary";
    }
  },
};
